module.exports = __webpack_public_path__ + "static/media/trag-2.dac8a1ed.png";